
import Vue from 'vue'
export default Vue.extend({
  name: 'SelectImportFile',
  props: {
    format: {
      type: String,
      default: '.csv'
    },
    btnText: {
      type: String,
      default: 'Далее'
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    loadingData: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      file: null as File | null
    }
  },
  computed: {
    getShortFileName () {
      if (this.file) {
        // @ts-ignore
        return this.file.name
      } else {
        return ''
      }
    }
  },
  watch: {
    'isDisabled' (val) {
      if (!val) {
        // @ts-ignore
        this.file = null
      }
    }
  }
})
